module.exports = __webpack_public_path__ + "static/media/search.4a6c5c93.svg";